import { render } from "./HomeForYou.vue?vue&type=template&id=085ffa92&scoped=true"
import script from "./HomeForYou.vue?vue&type=script&lang=js"
export * from "./HomeForYou.vue?vue&type=script&lang=js"

import "./HomeForYou.vue?vue&type=style&index=0&id=085ffa92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085ffa92"]])

export default __exports__